








import Vue from 'vue'
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl'
import { normalizeLanguage, DEFAULT_LANGUAGE, LANGUAGE_CULTURES } from '@/plugins/i18n'

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

import numbers from 'cldr-numbers-full/main/hu/numbers.json';
import currencies from 'cldr-numbers-full/main/hu/currencies.json';
import caGregorian from 'cldr-dates-full/main/hu/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/hu/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/hu/timeZoneNames.json';

// A Kendo komponensek (grid, dátumválasztó, számmező) beépített feliratai nyelvenként.
// A szám- és dátumformátum (intl locale) szándékosan minden nyelven magyar marad.
const messagesHu = {
    "datepicker": {
        "toggleCalendar": "Naptár ki/bekapcsolása"
    },
    "calendar": {
        "today": "Ma"
    },
    "dateinput": {
        "increment": "Növelés",
        "decrement": "Csökkentés"
    },
    "numerictextbox": {
        "increment": "Növelés",
        "decrement": "Csökkentés"
    },
    "grid": {
        "groupPanelEmpty": "Csoportosításhoz fogd meg és dobd ide az oszlop fejlécét",
        "noRecords": "Nincs adat",
        "pagerFirstPage": "Első oldal",
        "pagerPreviousPage": "Előző oldal",
        "pagerNextPage": "Következő oldal",
        "pagerLastPage": "Utolsó oldal",
        "pagerPage": "Oldal",
        "pagerOf": "Össz",
        "pagerItems": "Elemek",
        "pagerInfo": "{0} - {1} {2}",
        "pagerItemsPerPage": "Elem / oldal",
        "sortAscending": "Növekvő rendezés",
        "sortDescending": "Csökkenő rendezés",
        "filterEqOperator": "Egyenlő",
        "filterNotEqOperator": "Nem egyenlő",
        "filterIsNullOperator": "Null",
        "filterIsNotNullOperator": "Nem null",
        "filterIsEmptyOperator": "Üres",
        "filterIsNotEmptyOperator": "Nem üres",
        "filterStartsWithOperator": "Kezdődik",
        "filterContainsOperator": "Tartalmazza",
        "filterNotContainsOperator": "Nem tartalmazza",
        "filterEndsWithOperator": "Végződik",
        "filterGteOperator": "Nagyobb egyenlő",
        "filterGtOperator": "Nagyobb",
        "filterLteOperator": "Kisebb egyenlő",
        "filterLtOperator": "Kisebb",
        "filterIsTrue": "Igaz",
        "filterIsFalse": "Hamis",
        "filterBooleanAll": "Összes",
        "filterAfterOrEqualOperator": "Előző vagy egyenlő",
        "filterAfterOperator": "Következő vagy egyenlő",
        "filterBeforeOperator": "Előző",
        "filterBeforeOrEqualOperator": "Előző vagy egyenlő",
        "filterFilterButton": "Szűrés",
        "filterClearButton": "Szűrés törlése",
        "filterAndLogic": "ÉS",
        "filterOrLogic": "VAGY"
    }
};

const messagesEn = {
    "datepicker": {
        "toggleCalendar": "Toggle calendar"
    },
    "calendar": {
        "today": "Today"
    },
    "dateinput": {
        "increment": "Increase",
        "decrement": "Decrease"
    },
    "numerictextbox": {
        "increment": "Increase",
        "decrement": "Decrease"
    },
    "grid": {
        "groupPanelEmpty": "Drag a column header and drop it here to group by that column",
        "noRecords": "No data",
        "pagerFirstPage": "First page",
        "pagerPreviousPage": "Previous page",
        "pagerNextPage": "Next page",
        "pagerLastPage": "Last page",
        "pagerPage": "Page",
        "pagerOf": "of",
        "pagerItems": "items",
        "pagerInfo": "{0} - {1} of {2}",
        "pagerItemsPerPage": "items per page",
        "sortAscending": "Sort ascending",
        "sortDescending": "Sort descending",
        "filterEqOperator": "Is equal to",
        "filterNotEqOperator": "Is not equal to",
        "filterIsNullOperator": "Is null",
        "filterIsNotNullOperator": "Is not null",
        "filterIsEmptyOperator": "Is empty",
        "filterIsNotEmptyOperator": "Is not empty",
        "filterStartsWithOperator": "Starts with",
        "filterContainsOperator": "Contains",
        "filterNotContainsOperator": "Does not contain",
        "filterEndsWithOperator": "Ends with",
        "filterGteOperator": "Is greater than or equal to",
        "filterGtOperator": "Is greater than",
        "filterLteOperator": "Is less than or equal to",
        "filterLtOperator": "Is less than",
        "filterIsTrue": "Is true",
        "filterIsFalse": "Is false",
        "filterBooleanAll": "All",
        "filterAfterOrEqualOperator": "Is after or equal to",
        "filterAfterOperator": "Is after",
        "filterBeforeOperator": "Is before",
        "filterBeforeOrEqualOperator": "Is before or equal to",
        "filterFilterButton": "Filter",
        "filterClearButton": "Clear",
        "filterAndLogic": "AND",
        "filterOrLogic": "OR"
    }
};

const messagesDe = {
    "datepicker": {
        "toggleCalendar": "Kalender ein-/ausblenden"
    },
    "calendar": {
        "today": "Heute"
    },
    "dateinput": {
        "increment": "Erhöhen",
        "decrement": "Verringern"
    },
    "numerictextbox": {
        "increment": "Erhöhen",
        "decrement": "Verringern"
    },
    "grid": {
        "groupPanelEmpty": "Ziehen Sie eine Spaltenüberschrift hierher, um nach dieser Spalte zu gruppieren",
        "noRecords": "Keine Daten",
        "pagerFirstPage": "Erste Seite",
        "pagerPreviousPage": "Vorherige Seite",
        "pagerNextPage": "Nächste Seite",
        "pagerLastPage": "Letzte Seite",
        "pagerPage": "Seite",
        "pagerOf": "von",
        "pagerItems": "Einträge",
        "pagerInfo": "{0} - {1} von {2}",
        "pagerItemsPerPage": "Einträge pro Seite",
        "sortAscending": "Aufsteigend sortieren",
        "sortDescending": "Absteigend sortieren",
        "filterEqOperator": "Ist gleich",
        "filterNotEqOperator": "Ist ungleich",
        "filterIsNullOperator": "Ist null",
        "filterIsNotNullOperator": "Ist nicht null",
        "filterIsEmptyOperator": "Ist leer",
        "filterIsNotEmptyOperator": "Ist nicht leer",
        "filterStartsWithOperator": "Beginnt mit",
        "filterContainsOperator": "Enthält",
        "filterNotContainsOperator": "Enthält nicht",
        "filterEndsWithOperator": "Endet mit",
        "filterGteOperator": "Größer oder gleich",
        "filterGtOperator": "Größer als",
        "filterLteOperator": "Kleiner oder gleich",
        "filterLtOperator": "Kleiner als",
        "filterIsTrue": "Ist wahr",
        "filterIsFalse": "Ist falsch",
        "filterBooleanAll": "Alle",
        "filterAfterOrEqualOperator": "Ist nach oder gleich",
        "filterAfterOperator": "Ist nach",
        "filterBeforeOperator": "Ist vor",
        "filterBeforeOrEqualOperator": "Ist vor oder gleich",
        "filterFilterButton": "Filtern",
        "filterClearButton": "Zurücksetzen",
        "filterAndLogic": "UND",
        "filterOrLogic": "ODER"
    }
};

load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    currencies,
    caGregorian,
    dateFields,
    timeZoneNames
)

loadMessages(messagesHu, LANGUAGE_CULTURES.hu)
loadMessages(messagesEn, LANGUAGE_CULTURES.en)
loadMessages(messagesDe, LANGUAGE_CULTURES.de)

export default Vue.extend({
    components: {
        'localization': LocalizationProvider,
        'intl': IntlProvider
    },

    computed: {
        // a vue-i18n locale reaktív: a login oldali nyelvváltás után újratöltés nélkül is követi
        language(): string {
            return LANGUAGE_CULTURES[normalizeLanguage(this.$i18n.locale) || DEFAULT_LANGUAGE]
        }
    }
})
